export const iconFontAwesomeTransportationTruckDroplet = (
	<i className="fa-solid fa-truck-droplet"></i>
);
